<div mat-dialog-title>
    <div flex fxLayout="row">
        <div fxFlex>
            <span class="mat-display-1" *ngIf="!isUpdate">Nueva Reserva</span>
            <span class="mat-display-1" *ngIf="isUpdate">Editar Reserva</span>
        </div>
        <div fxFlex class="text-right">
            <mat-menu #appMenu="matMenu">
                <button mat-menu-item><a>Cancelar Reserva</a></button>
                <button mat-menu-item><a>Confirmar Reserva</a></button>
            </mat-menu>
            <button mat-icon-button [matMenuTriggerFor]="appMenu">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
    </div>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit()">

    <div mat-dialog-content>
        <table class="table text-muted">
            <tr>
                <td width="200">Fecha:</td>
                <td>
                    <mat-form-field>
                        <input class="text-left" matInput [matDatepicker]="currentDateSelector" [formControl]="f_date"
                            [min]="minDate" (dateChange)="addEvent('change', $event)" name="f_date" required>
                        <mat-datepicker-toggle matSuffix [for]="currentDateSelector"></mat-datepicker-toggle>
                        <mat-datepicker #currentDateSelector [startAt]="f_date" disabled="false"></mat-datepicker>
                        <mat-error *ngIf="f_date.invalid">Seleccione una fecha válida</mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Tamaño del partido:</td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="reserva.field_capacity" name="field_capacity" #field_capacity="ngModel"
                            required (ngModelChange)="changeCapacity($event)">
                            <mat-option *ngFor="let size of fieldSizes"
                                [value]="size.description">{{size.display_description}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="field_capacity.invalid">Debe seleccionar la cantidad de jugadores</mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Tipo de reserva:</td>
                <td>
                    <mat-form-field>
                        <mat-select name="selectedType" [(ngModel)]="selectedType" required (ngModelChange)="validateTypeReserve($event)">
                            <mat-option *ngFor="let type of typeOptions" [value]="type.value">
                                {{ formatTypeReservation(type.name) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Se realizara un depósito para la reserva?</td>
                <td>
                    <mat-form-field>
                        <mat-select name="paymentActiveSelect" [(ngModel)]="paymentActiveSelect"
                            (ngModelChange)="validateSenaReserve(); changeCapacity($event)">
                            <mat-option [value]="null" *ngIf="!paymentActiveSelect">Seleccionar opcion</mat-option>
                            <mat-option [value]="true">Si</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
            <tr *ngIf="paymentActive">
                <td>Precio cancha:</td>
                <td>
                    <mat-form-field>
                        <input matInput name="amount" [(ngModel)]="paymentVariable.amount" placeholder="Monto total"
                            type="number">
                    </mat-form-field>
                </td>
            </tr>
            <tr *ngIf="paymentActive">
                <td>Seña:</td>
                <td>
                    <mat-form-field>
                        <input matInput name="deposit" [(ngModel)]="paymentVariable.deposit" placeholder="Seña"
                            type="number">
                    </mat-form-field>
                </td>
            </tr>
            <tr *ngIf="paymentActive">
                <td>Saldo:</td>
                <td>
                    <mat-form-field>
                        <input matInput name="balance" [value]="paymentVariable.amount - paymentVariable.deposit"
                            placeholder="Saldo" type="number" disabledg>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Hora Inicio:</td>
                <td>
                    <mat-form-field>
                        <mat-select name="turno" [(ngModel)]="f_turno" (ngModelChange)="onHourSelect()" required>
                            <mat-option *ngFor="let shift of openShifts" value="{{shift}}">{{shift}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Hora Fin:</td>
                <td>
                    <mat-form-field>
                        <mat-select name="turno_fin" [(ngModel)]="f_turno_fin" (ngModelChange)="onHourSelectFin()"
                            [disabled]="isTypeReserveInvalid">
                            <mat-option *ngFor="let shift of openShiftsFin" value="{{shift}}">{{shift}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div *ngIf="isEndTimeInvalid">
                        <span class="message-error-hour">La hora de fin no debe ser menor a hora de inicio</span>
                    </div>
                </td>
            </tr>
            <tr>
                <td>Descripción:</td>
                <td>
                    <mat-form-field>
                        <input matInput name="descripcion" [(ngModel)]="reserva.description" placeholder="Descripcion"
                            type="text" rows="4">
                    </mat-form-field>
                </td>
            </tr>

            <tr>
                <td>Datos Contacto:</td>
                <td>
                    <mat-form-field>
                        <input matInput name="name" [(ngModel)]="reserva.name" placeholder="Nombre" required>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td></td>
                <td>
                    <mat-form-field>
                        <input matInput name="phone" type="number" [(ngModel)]="reserva.phone" placeholder="Teléfono"
                            required>
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]>Cerrar</button>
        <button mat-raised-button mat-raised-button color="primary" type="submit"
            [disabled]="f.invalid || isEndTimeInvalid || clickButton">
            <span *ngIf="!isUpdate">Reservar Turno</span>
            <span *ngIf="isUpdate">Actualizar Turno</span>
        </button>
    </div>

</form>